import Devlog_2026_02_11 from './2026.02.11.vue';
import Devlog_2026_02_08 from './2026.02.08.vue';
import Devlog_2026_01_30 from './2026.01.30.vue';
import Devlog_2025_03_03 from './2025.03.03.vue';
import Devlog_2025_02_25 from './2025.02.25.vue';
import Devlog_2025_02_11 from './2025.02.11.vue';
import Devlog_2025_01_18 from './2025.01.18.vue';
import Devlog_2025_01_04 from './2025.01.04.vue';
import Devlog_2024_12_30 from './2024.12.30.vue';
import Devlog_2024_12_26 from './2024.12.26.vue';
import Devlog_2024_12_21 from './2024.12.21.vue';
import Devlog_2024_12_14 from './2024.12.14.vue';
import Devlog_2024_12_11 from './2024.12.11.vue';
import Devlog_2024_12_09 from './2024.12.09.vue';
import Devlog_2024_12_04 from './2024.12.04.vue';
import Devlog_2024_12_02 from './2024.12.02.vue';
import Devlog_2024_11_29 from './2024.11.29.vue';
import Devlog_2024_11_27 from './2024.11.27.vue';
import Devlog_2024_11_22 from './2024.11.22.vue';
import Devlog_2024_11_16 from './2024.11.16.vue';
import Devlog_2024_11_05 from './2024.11.05.vue';
import Devlog_2024_11_01 from './2024.11.01.vue';

export default [
  Devlog_2026_02_11,
  Devlog_2026_02_08,
  Devlog_2026_01_30,
  Devlog_2025_03_03,
  Devlog_2025_02_25,
  Devlog_2025_02_11,
  Devlog_2025_01_18,
  Devlog_2025_01_04,
  Devlog_2024_12_30,
  Devlog_2024_12_26,
  Devlog_2024_12_21,
  Devlog_2024_12_14,
  Devlog_2024_12_11,
  Devlog_2024_12_09,
  Devlog_2024_12_04,
  Devlog_2024_12_02,
  Devlog_2024_11_29,
  Devlog_2024_11_27,
  Devlog_2024_11_22,
  Devlog_2024_11_16,
  Devlog_2024_11_05,
  Devlog_2024_11_01,
  // Future devlog entries will be added here
];
